export default __webpack_public_path__ + "ad760e88611b4d3215de6a7901c0e134.svg";